
export class ItemMenuLateral {

    constructor(public nome: string,
                public rota?: string,
                public icone?:string,
                public subItens?: Array<ItemMenuLateral>) {}
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/menu-lateral/item-menu-lateral.model.ts